import users from '../config/users.json';

const normalizeEmail = (email) =>
  (email || '').trim().toLowerCase();

const getUserByEmail = (email) => {
  const normalizedEmail = normalizeEmail(email);

  return (
    users.find(
      (user) => normalizeEmail(user.email) === normalizedEmail
    ) || null
  );
};

const isDashboardCommercialUser = (email) => {
  return getUserByEmail(email) !== null;
};

const getProfile = (email) => {
  const user = getUserByEmail(email);

  return user?.profile || null;
};

const hasProfile = (email, profile) => {
  const currentProfile = getProfile(email);

  return currentProfile === profile;
};

export const userService = {
  getUserByEmail,
  isDashboardCommercialUser,
  getProfile,
  hasProfile,
};

export default userService;